import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';
import styles from '../static/styles/CannonClashInstructions.module.css';

const CannonClashInstructions = ({ isOpen, onClose }) => {
    const navigate = useNavigate();

    if (!isOpen) return null;

    const handleTournamentsNavigation = () => {
        onClose();
        navigate('/tournaments');
    };

    const handleOverlayClick = (e) => {
        if (e.target === e.currentTarget) {
            onClose();
        }
    };

    const slides = [
        {
            title: 'How to Join',
            content: (
                <div className={styles.rulesContainer}>
                    <div className={styles.rule}>Click "Join Now" to register for the tournament</div>
                    <div className={styles.rule}>Receive SMS with Room ID and Match Time one hour before start</div>
                    <div className={styles.rule}>At match time, click "Play Now" and enter your Room ID</div>
                </div>
            )
        },
        {
            title: 'Game Controls',
            content: (
                <div className={styles.rulesContainer}>
                    <div className={styles.rule}>Move Cannon: Drag left or right</div>
                    <div className={styles.rule}>Fire Minions: Press the cannon to launch</div>
                    <div className={styles.rule}>Your Cannon is marked as "YOU"</div>
                </div>
            )
        },
        {
            title: 'Objective',
            content: (
                <div className={styles.rulesContainer}>
                    <div className={styles.rule}>Destroy the opponent's towers to win</div>
                    <div className={styles.rule}>First eliminate the two side towers</div>
                    <div className={styles.rule}>Then your minions advance to destroy the center tower</div>
                </div>
            )
        },
        {
            title: 'Tournament Rules',
            content: (
                <div className={styles.rulesContainer}>
                    <div className={styles.rule}>Progressive 1v1 knockout format</div>
                    <div className={styles.rule}>No-show = automatic win for opponent</div>
                    <div className={styles.rule}>Winners advance, losers eliminated</div>
                    <div className={styles.rule}>Rewards credited instantly to wallet</div>
                </div>
            )
        }
    ];

    return (
        <div className={styles.overlay} onClick={handleOverlayClick}>
            <div className={styles.container}>
                <div className={styles.header}>
                    <h2>How to Play</h2>
                </div>

                <div className={styles.popup}>
                    <button className={styles.closeButton} onClick={onClose}>×</button>

                    <Swiper
                        modules={[Pagination]}
                        pagination={{
                            clickable: true
                        }}
                        spaceBetween={0}
                        slidesPerView={1}
                        className={styles.swiper}
                        loop
                    >
                        {slides.map((slide, index) => (
                            <SwiperSlide key={index}>
                                <div className={styles.content}>
                                    <div className={styles.roundHeader}>
                                        <h2>{slide.title}</h2>
                                    </div>
                                    {slide.content}
                                </div>
                            </SwiperSlide>
                        ))}
                    </Swiper>
                </div>
            </div>
        </div>
    );
};

export default CannonClashInstructions;